<template>
    <div>
        <BaseCheckbox
            v-model="person.isPostbox"
            class="mb-3">
            {{ $t('eventRegistration.person.isPostbox') }}
        </BaseCheckbox>
        <div class="row">
            <div class="col-12 col-sm-4 col-md-12 col-xl-4">
                <base-input
                    v-model="person.zipValue"
                    :label="$t('eventRegistration.person.zip')"
                    autocomplete="postal-code"
                    :rules="{max: 10}"
                    :required="required" />
            </div>
            <div class="col-12 col-sm-8 col-md-12 col-xl-8 ">
                <base-input
                    v-model="person.cityValue"
                    :label="$t('eventRegistration.person.city')"
                    autocomplete="address-level2"
                    :rules="{addressIsIncomplete: isZipValueValid, max: 60}"
                    :required="required" />
            </div>
        </div>

        <base-input
            v-if="person.isPostbox"
            v-model="person.postboxNumber"
            :label="$t('eventRegistration.person.postboxNumber')"
            :rules="{addressIsIncomplete: isZipValueValid, max: 30}"
            :required="required" />
        <div
            v-else
            class="row">
            <div class="col-12 col-sm-8 col-md-12 col-xl-8 ">
                <base-input
                    v-model="person.streetValue"
                    :label="$t('eventRegistration.person.street')"
                    :rules="{addressIsIncomplete: isZipValueValid, max: 80}"
                    :required="required" />
            </div>
            <div class="col-12 col-sm-4 col-md-12 col-xl-4">
                <base-input
                    v-model="person.houseNumber"
                    :label="$t('eventRegistration.person.houseNumber')"
                    :rules="{addressIsIncomplete: isZipValueValid, max: 10}"
                    :required="required" />
            </div>
        </div>
        <div v-if="person.cityValue && (person.isPostbox || person.streetValue)">
            <base-input
                :label="$t('eventRegistration.person.addressAdditional')"
                :rules="{max: 80}">
                <textarea
                    v-model="person.additional1"
                    class="form-control"
                    rows="1" />
            </base-input>
        </div>
    </div>
</template>

<script>
import registrationPersonMixin from "@/mixins/registration/registrationPersonMixin";
import formSelectChoiceMixin from "@/mixins/registration/formSelectChoiceMixin";

export default {
    name: "RegistrationAddressInput",
    mixins: [formSelectChoiceMixin, registrationPersonMixin],
    props: {
        required: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isZipValueValid() {
            return !!(this.person.zipValue && this.person.zipValue.length === 5 && !isNaN(this.person.zipValue));
        }
    }
}
</script>

<style scoped>

</style>
